(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7517],{

/***/ 1743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var _wds_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5420);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useStyles = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_0__/* .createMemoStyles */ .Im)(function (_a) {
    var spacing = _a.spacing, border = _a.border;
    return ({
        wrenchBox: function (_a) {
            var _b, _c;
            var display = _a.display, flexProperties = _a.flexProperties, gridProperties = _a.gridProperties, borderColor = _a.borderColor;
            var gap = gridProperties.gap, gridStyleProperties = __rest(gridProperties, ["gap"]);
            var _d = flexProperties.flexItemGrow, flexItemGrow = _d === void 0 ? undefined : _d, _e = flexProperties.flexWrap, flexWrap = _e === void 0 ? undefined : _e, flexStyleProperties = __rest(flexProperties, ["flexItemGrow", "flexWrap"]);
            return (0,_wds_utils__WEBPACK_IMPORTED_MODULE_0__/* .removeUndefinedProperties */ .jB)(__assign(__assign(__assign({}, gridStyleProperties), flexStyleProperties), { justifyContent: (_b = gridStyleProperties.justifyContent) !== null && _b !== void 0 ? _b : flexStyleProperties.justifyContent, alignItems: (_c = gridStyleProperties.alignItems) !== null && _c !== void 0 ? _c : flexStyleProperties.alignItems, flexGrow: flexItemGrow && 1, flexWrap: flexWrap && 'wrap', display: display !== null && display !== void 0 ? display : null, gap: gap ? spacing[gap] : null, border: borderColor && border[borderColor] }));
        },
    });
});

/**
 * [IMPORTANT]
 * We have to call createSpacingStyles at the component level
 * Otherwise, the styles will be overridden by the global styles
 * This happens because JSS loads the styles in sequence
 */
var useSpacingStyles = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_0__/* .createSpacingStyles */ .js)();
var Box = function (props) {
    var containerRef = props.containerRef, borderColor = props.borderColor, className = props.className, children = props.children, _a = props.element, element = _a === void 0 ? 'div' : _a, display = props.display, alignItems = props.alignItems, justifyContent = props.justifyContent, flexDirection = props.flexDirection, flexItemGrow = props.flexItemGrow, flexJustify = props.flexJustify, flexAlign = props.flexAlign, flexWrap = props.flexWrap, gridTemplateColumns = props.gridTemplateColumns, gridTemplateRows = props.gridTemplateRows, gridAutoFlow = props.gridAutoFlow, placeItems = props.placeItems, gap = props.gap, m = props.m, mx = props.mx, my = props.my, mt = props.mt, mb = props.mb, ml = props.ml, mr = props.mr, p = props.p, px = props.px, py = props.py, pt = props.pt, pb = props.pb, pl = props.pl, pr = props.pr, rest = __rest(props, ["containerRef", "borderColor", "className", "children", "element", "display", "alignItems", "justifyContent", "flexDirection", "flexItemGrow", "flexJustify", "flexAlign", "flexWrap", "gridTemplateColumns", "gridTemplateRows", "gridAutoFlow", "placeItems", "gap", "m", "mx", "my", "mt", "mb", "ml", "mr", "p", "px", "py", "pt", "pb", "pl", "pr"]);
    var flexProperties = {
        alignItems: alignItems !== null && alignItems !== void 0 ? alignItems : flexAlign,
        justifyContent: justifyContent !== null && justifyContent !== void 0 ? justifyContent : flexJustify,
        flexDirection: flexDirection,
        flexItemGrow: flexItemGrow,
        flexWrap: flexWrap,
    };
    var gridProperties = {
        justifyContent: justifyContent,
        alignItems: alignItems,
        gridTemplateColumns: gridTemplateColumns,
        gridTemplateRows: gridTemplateRows,
        gridAutoFlow: gridAutoFlow,
        placeItems: placeItems,
        gap: gap,
    };
    var wrenchSpacing = useSpacingStyles({
        m: m,
        mx: mx,
        my: my,
        mt: mt,
        mb: mb,
        ml: ml,
        mr: mr,
        p: p,
        px: px,
        py: py,
        pt: pt,
        pb: pb,
        pl: pl,
        pr: pr,
    }).wrenchSpacing;
    var wrenchBox = useStyles({
        flexProperties: flexProperties,
        gridProperties: gridProperties,
        display: display,
        borderColor: borderColor,
    }).wrenchBox;
    // TODO: remove this type coercion when upgrading to React v18
    var Element = element;
    var classNames = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_0__/* .clsx */ .Wy)(className, wrenchBox, wrenchSpacing);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(Element, __assign({ className: classNames, ref: containerRef }, rest), children));
};
Box.defaultProps = {
    element: 'div',
    containerRef: undefined,
    display: undefined,
    children: null,
    className: undefined,
};




/***/ }),

/***/ 7837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* binding */ Button; }
});

// UNUSED EXPORTS: BUTTON_COLORS, BUTTON_SIZES, BUTTON_TYPES, VARIANTS, guardAnchor

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/theming/dist/theming.esm.js
var theming_esm = __webpack_require__(1928);
// EXTERNAL MODULE: ./node_modules/@wds/utils/dist/index.es.js
var index_es = __webpack_require__(5420);
;// CONCATENATED MODULE: ./node_modules/@wds/progress-circle/dist/index.es.js



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useStyles = (0,index_es/* createMemoStyles */.Im)(function (theme) {
    var spacing = theme.spacing, palette = theme.palette, type = theme.type, motion = theme.motion;
    var width = function (s) {
        return {
            xs: spacing[4],
            sm: spacing[6],
            md: spacing[8],
            lg: spacing[10],
        }[s];
    };
    var font = function (s) {
        return {
            xs: type.fontSize.bodySm,
            sm: type.fontSize.bodySm,
            md: type.fontSize.body,
            lg: type.fontSize.pageTitle,
        }[s];
    };
    var fontWeight = function (s) {
        return {
            xs: type.fontWeight.regular,
            sm: type.fontWeight.regular,
            md: type.fontWeight.medium,
            lg: type.fontWeight.medium,
        }[s];
    };
    var height = width;
    var rotate = {
        '@keyframes rotate': {
            '100%': {
                transform: 'rotate(360deg)',
            },
        },
    };
    var stretch = {
        '@keyframes stretch': {
            '0%': {
                strokeDasharray: '339.292, 339.292',
                strokeDashoffset: '203.57519999999997',
                animationTimingFunction: 'cubic-bezier(0.3, 0, 1, 1)',
            },
            '40%': {
                strokeDasharray: '339.292, 339.292',
                strokeDashoffset: '253.57519999999997',
                animationTimingFunction: 'cubic-bezier(0, 0, 0.9, 1)',
            },
            '65%': {
                strokeDashoffset: '303.57519999999997',
            },
            '100%': {
                strokeDashoffset: '203.57519999999997',
            },
        },
    };
    var fillColor = function (color) { return color === 'dark' || color === 'light' ? palette.text[color] : palette[color].main; };
    var bgColor = function (color) {
        if (color === 'dark') {
            return palette.transparent.dark;
        }
        return color === 'light' ? palette.transparent.light : palette.muted.main;
    };
    var progressCircleStyles = __assign(__assign(__assign({}, rotate), stretch), { wrenchProgressCircle: function (_a) {
            var size = _a.size, continuous = _a.continuous;
            return ({
                display: 'inline-block',
                position: 'relative',
                width: width(size),
                height: height(size),
                fill: 'none',
                '-webkit-transform': continuous && 'translate3d(0,0,0)',
            });
        }, wrenchCirclePath: function () { return ({
            transform: 'rotate(-90deg)',
        }); }, wrenchCirclePathGroup: function (_a) {
            var continuous = _a.continuous;
            return ({
                animation: continuous && '$rotate 1s linear infinite',
                transformOrigin: continuous && 'center center',
            });
        }, wrenchCirclePathBorder: function (_a) {
            var color = _a.color;
            return ({
                stroke: bgColor(color),
            });
        }, wrenchCirclePathFill: function (_a) {
            var color = _a.color, continuous = _a.continuous, animateOnLoad = _a.animateOnLoad;
            return ({
                transition: animateOnLoad && "all 1s ".concat(motion.curve.ease),
                stroke: fillColor(color),
                strokeLinecap: 'round',
                strokeDasharray: continuous && '339.292, 339.292',
                strokeDashoffset: continuous && '203.57519999999997',
                animation: continuous && '$stretch 1s infinite',
                transformOrigin: continuous && 'center center',
            });
        }, wrenchCircleDisplay: function (_a) {
            var size = _a.size;
            return ({
                position: 'absolute',
                top: '0',
                left: '0',
                width: width(size),
                height: height(size),
                fontSize: font(size),
                fontWeight: fontWeight(size),
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
            });
        } });
    return progressCircleStyles;
});

var ProgressCircle = function (_a) {
    var _b = _a.children, children = _b === void 0 ? undefined : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, _d = _a.percent, percent = _d === void 0 ? undefined : _d, _e = _a.color, color = _e === void 0 ? 'success' : _e, _f = _a.continuous, continuous = _f === void 0 ? false : _f, _g = _a.valueMax, valueMax = _g === void 0 ? undefined : _g, _h = _a.valueMin, valueMin = _h === void 0 ? undefined : _h, _j = _a.valueText, valueText = _j === void 0 ? undefined : _j, _k = _a.animateOnLoad, animateOnLoad = _k === void 0 ? false : _k, rest = __rest(_a, ["children", "size", "percent", "color", "continuous", "valueMax", "valueMin", "valueText", "animateOnLoad"]);
    var initialPercent = animateOnLoad ? 0 : percent;
    var _l = (0,react.useState)(initialPercent), p = _l[0], setPercent = _l[1];
    (0,react.useEffect)(function () { return setPercent(percent); }, [percent]);
    var _m = useStyles({ color: color, size: size, continuous: continuous, animateOnLoad: animateOnLoad }), wrenchProgressCircle = _m.wrenchProgressCircle, wrenchCirclePath = _m.wrenchCirclePath, wrenchCirclePathGroup = _m.wrenchCirclePathGroup, wrenchCirclePathBorder = _m.wrenchCirclePathBorder, wrenchCirclePathFill = _m.wrenchCirclePathFill, wrenchCircleDisplay = _m.wrenchCircleDisplay;
    var circleOptions = {
        lg: {
            strokeWidth: 8,
            radius: 56,
        },
        sm: {
            strokeWidth: 16,
            radius: 52,
        },
        md: {
            strokeWidth: 12,
            radius: 54,
        },
        xs: {
            strokeWidth: 20,
            radius: 50,
        },
    };
    var _o = circleOptions[size], strokeWidth = _o.strokeWidth, radius = _o.radius;
    var circumference = radius * 2 * Math.PI;
    var valueNow = p != null ? p : undefined;
    var strokeDasharray = !continuous
        ? "".concat(circumference, " ").concat(circumference)
        : undefined;
    var strokeDashoffset = !continuous && p != null ? circumference * ((100 - p) / 100) : undefined;
    return (react.createElement("div", __assign({ className: wrenchProgressCircle, role: "progressbar", "aria-valuenow": valueNow, "aria-valuemax": valueMax, "aria-valuemin": valueMin, "aria-valuetext": valueText }, (0,index_es/* safeRest */.Q6)(rest)),
        react.createElement("svg", { className: wrenchCirclePath, role: "img", "aria-label": "Progress", viewBox: "0 0 120 120" },
            react.createElement("g", { className: wrenchCirclePathGroup },
                react.createElement("circle", { className: wrenchCirclePathBorder, cx: "60", cy: "60", r: radius, strokeWidth: strokeWidth }),
                react.createElement("circle", { className: wrenchCirclePathFill, cx: "60", cy: "60", r: radius, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeDashoffset: strokeDashoffset }))),
        children && (react.createElement("div", { className: wrenchCircleDisplay }, children))));
};

var PROGRESS_CIRCLE_COLORS = (/* unused pure expression or super */ null && ([
    'primary',
    'secondary',
    'success',
    'warning',
    'error',
    'upgrade',
    'info',
    'dark',
    'light',
]));
var PROGRESS_CIRCLE_SIZES = (/* unused pure expression or super */ null && (['xs', 'sm', 'md', 'lg']));



// EXTERNAL MODULE: ./node_modules/@wds/styles/dist/index.es.js
var dist_index_es = __webpack_require__(4779);
;// CONCATENATED MODULE: ./node_modules/@wds/button/dist/index.es.js






/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var index_es_assign = function() {
    index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return index_es_assign.apply(this, arguments);
};

function index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var index_es_useStyles = (0,index_es/* createMemoStyles */.Im)(function (theme) {
    var type = theme.type, radius = theme.radius, shadow = theme.shadow, palette = theme.palette, spacing = theme.spacing;
    var button = {
        height: {
            sm: 32,
            md: 40,
            lg: 48,
        },
        fontSize: {
            sm: type.fontSize.bodySm,
            md: type.fontSize.body,
            lg: type.fontSize.body,
        },
        padding: {
            sm: spacing[4],
            md: spacing[5],
            lg: spacing[6],
        },
        borderRadius: radius.small,
        boxShadow: shadow.none,
    };
    var hoverFocus = function () { return ({
        transition: 'none',
        textDecoration: 'none',
    }); };
    var active = function () { return ({
        transition: 'none',
        outline: 'none',
    }); };
    var variantSolid = function (textColor, color, pressedColor, loading) { return ({
        color: loading ? 'transparent' : textColor,
        borderColor: pressedColor,
        backgroundColor: pressedColor,
        '&:hover': {
            boxShadow: shadow.sky,
        },
        '&:hover, &:focus': index_es_assign(index_es_assign({}, hoverFocus()), { borderColor: (0,index_es/* lighten */.$n)(0.03, color), backgroundColor: (0,index_es/* lighten */.$n)(0.03, color) }),
        '&:active': index_es_assign(index_es_assign({}, active()), { borderColor: color, backgroundColor: color }),
    }); };
    var variantGhost = function (backgroundColor, pressedColor, loading) { return ({
        color: loading ? 'transparent' : pressedColor,
        borderColor: pressedColor,
        backgroundColor: 'transparent',
        '&:hover, &:focus': index_es_assign(index_es_assign({}, hoverFocus()), { backgroundColor: backgroundColor }),
        '&:active': index_es_assign(index_es_assign({}, active()), { borderColor: pressedColor }),
    }); };
    var variantText = function (backgroundColor, pressedColor, loading) { return ({
        color: loading ? 'transparent' : pressedColor,
        borderColor: 'transparent',
        backgroundColor: 'transparent',
        '&:hover, &:focus': index_es_assign(index_es_assign({}, hoverFocus()), { borderColor: backgroundColor, backgroundColor: backgroundColor }),
    }); };
    var colorAlt = function (loading, variant) {
        var borderColor = variant === 'text' ? 'transparent' : palette.text.dark;
        return {
            color: loading ? 'transparent' : palette.text.dark,
            borderColor: borderColor,
            backgroundColor: palette.background.light,
            '&:hover': {
                boxShadow: shadow.sky,
            },
            '&:hover, &:focus': index_es_assign(index_es_assign({}, hoverFocus()), { borderColor: borderColor, backgroundColor: palette.background.main }),
            '&:active': index_es_assign(index_es_assign({}, active()), { borderColor: borderColor, backgroundColor: palette.background.light }),
        };
    };
    var svgMargin = function (leftIcon, rightIcon, size) {
        var iconMargin = function (s) {
            return {
                sm: '8px',
                md: '16px',
                lg: '16px',
            }[s];
        };
        return {
            '& > svg:first-child': index_es_assign({}, (leftIcon && {
                marginRight: "".concat(iconMargin(size)),
            })),
            '& > svg:last-child': index_es_assign({}, (rightIcon && {
                marginLeft: "".concat(iconMargin(size)),
            })),
        };
    };
    var iconPadding = function (size) {
        return {
            sm: spacing[2],
            md: spacing[4],
            lg: spacing[5],
        }[size];
    };
    return {
        wrenchButton: function (_a) {
            var _b, _c, _d;
            var color = _a.color, variant = _a.variant, _e = _a.size, size = _e === void 0 ? 'md' : _e, pressed = _a.pressed, stretched = _a.stretched, iconOnly = _a.iconOnly, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, _f = _a.loading, loading = _f === void 0 ? false : _f;
            var buttonColor = ((_b = palette[color]) === null || _b === void 0 ? void 0 : _b.main) ||
                palette.text[color] ||
                palette.text.dark;
            var pressedColor = pressed ? (0,index_es/* darken */._j)(0.03, buttonColor) : buttonColor;
            var isStretched = stretched
                ? { display: 'flex', width: '100%' }
                : { display: 'inline-flex' };
            return index_es_assign(index_es_assign(index_es_assign(index_es_assign(index_es_assign(index_es_assign(index_es_assign({}, isStretched), { boxSizing: 'border-box', fontWeight: type.fontWeight.medium, fontFamily: type.fontFamily.base, '-webkit-font-smoothing': 'antialiased', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', position: 'relative', borderRadius: button.borderRadius, textDecoration: 'none', border: '1px solid transparent', boxShadow: button.boxShadow, transition: 'color 0.4s, border-color 0.4s, background-color 0.4s, box-shadow 0.4s', padding: [0, iconOnly ? iconPadding(size) : button.padding[size]], fontSize: size ? button.fontSize[size] : null, height: size ? button.height[size] : null, '&:hover, &:focus': hoverFocus(), '&:active': active(), '&[disabled], &[aria-disabled="true"]': {
                    pointerEvents: 'none',
                    opacity: '0.4',
                } }), (variant === 'solid' &&
                variantSolid((_d = (_c = palette[color]) === null || _c === void 0 ? void 0 : _c.contrast) !== null && _d !== void 0 ? _d : '', buttonColor, pressedColor, loading))), (variant === 'ghost' &&
                variantGhost(palette.background.accent, pressedColor, loading))), (variant === 'text' &&
                variantText(palette.background.accent, pressedColor, loading))), ((leftIcon || rightIcon) && svgMargin(leftIcon, rightIcon, size))), (color === 'alt' && colorAlt(loading, variant)));
        },
        wrenchButtonLoading: function () { return ({
            position: 'absolute',
            display: 'flex',
        }); },
    };
});

var Button = function (_a) {
    var ariaPressed = _a.ariaPressed, buttonType = _a.buttonType, children = _a.children, _b = _a.color, color = _b === void 0 ? 'primary' : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, href = _a.href, label = _a.label, size = _a.size, stretched = _a.stretched, variant = _a.variant, rest = index_es_rest(_a, ["ariaPressed", "buttonType", "children", "color", "loading", "disabled", "href", "label", "size", "stretched", "variant"]);
    var _e = (0,react.useState)(ariaPressed !== null && ariaPressed !== void 0 ? ariaPressed : false), pressed = _e[0], setPressed = _e[1];
    (0,react.useEffect)(function () {
        if (ariaPressed !== pressed)
            setPressed(!pressed);
    }, [ariaPressed, pressed]);
    var numberOfChildren = react.Children.count(children);
    var reactChildren = react.Children.toArray(children);
    var iconOnly = !!(numberOfChildren === 1 && (0,index_es/* getDisplayName */.Gf)(reactChildren[0]).includes('WithIcon'));
    var leftIcon = !!(numberOfChildren > 1 && (0,index_es/* getDisplayName */.Gf)(reactChildren[0]).includes('WithIcon'));
    var rightIcon = !!(numberOfChildren > 1 && (0,index_es/* getDisplayName */.Gf)(reactChildren[reactChildren.length - 1]).includes('WithIcon'));
    if (iconOnly && !label) {
        console.warn('A label is required when the child of a Button is an icon');
    }
    var rel;
    if (href) {
        // https://mathiasbynens.github.io/rel-noopener/
        var autoAddRel = rest.target && rest.target === '_blank' && !rest.rel;
        rel = autoAddRel ? 'noopener noreferrer' : undefined;
    }
    var theme = (0,theming_esm/* useTheme */.Fg)();
    var _f = index_es_useStyles({
        color: color,
        variant: variant,
        size: size,
        stretched: stretched,
        pressed: pressed,
        theme: theme,
        iconOnly: iconOnly,
        leftIcon: leftIcon,
        rightIcon: rightIcon,
        loading: loading
    }), wrenchButton = _f.wrenchButton, wrenchButtonLoading = _f.wrenchButtonLoading;
    var classNames = (0,index_es/* clsx */.Wy)(wrenchButton, 
    // Static class used for internal reference
    // Ex. ButtonGroup conditional styles
    variant ? "wrenchButton--".concat(variant) : null, color ? "wrenchButton--".concat(color) : null);
    var isDisabled = loading || disabled;
    if ((0,index_es/* conditionGuard */.U4)(rest, !!href)) {
        return (react.createElement("a", index_es_assign({}, (0,index_es/* safeRest */.Q6)(rest), { className: classNames, href: !isDisabled ? href : undefined, role: isDisabled ? 'link' : undefined, "aria-disabled": isDisabled ? 'true' : undefined, title: label, rel: rel }), children));
    }
    var colorValue = color === 'alt' ? theme.palette.background.light : theme.palette[color].main;
    var contrastColor = (0,index_es/* getContrastColor */.RN)(colorValue);
    return (react.createElement("button", index_es_assign({}, (0,index_es/* safeRest */.Q6)(rest), { className: classNames, 
        // eslint-disable-next-line react/button-has-type
        type: buttonType, disabled: isDisabled, "aria-pressed": ariaPressed, "aria-label": label }),
        loading &&
            react.createElement("span", { className: wrenchButtonLoading },
                react.createElement(ProgressCircle, { color: contrastColor, size: 'xs', continuous: true })),
        children));
};
Button.defaultProps = {
    ariaPressed: false,
    buttonType: 'button',
    color: 'primary',
    loading: false,
    disabled: false,
    href: undefined,
    label: undefined,
    size: 'md',
    stretched: false,
    variant: 'solid',
};

var BUTTON_COLORS = __spreadArray(['alt', 'link'], dist_index_es/* SEMANTIC_COLORS */.kg, true);
var VARIANTS = (/* unused pure expression or super */ null && (['solid', 'ghost', 'text']));
var BUTTON_TYPES = (/* unused pure expression or super */ null && (['button', 'reset', 'submit']));
var BUTTON_SIZES = (/* unused pure expression or super */ null && (['sm', 'md', 'lg']));
var guardAnchor = function (rest, href) { return !!href; };




/***/ }),

/***/ 295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ Typography; }
/* harmony export */ });
/* unused harmony exports ALIGNMENTS, COMPONENTS, TYPOGRAPHY_COLORS, VARIANTS */
/* harmony import */ var _wds_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5420);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _wds_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4779);




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var isNotLink = function (t) {
    return t !== 'link';
};
var hasFontWeight = function (t) {
    return typeof t.fontWeight === 'string' || typeof t.fontWeight === 'number';
};
var useStyles = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_0__/* .createMemoStyles */ .Im)(function (_a) {
    var _b = _a.type, fontFamily = _b.fontFamily, fontSize = _b.fontSize, fontWeight = _b.fontWeight, palette = _a.palette;
    return {
        wrenchTypography: function (_a) {
            var align = _a.align, color = _a.color, variant = _a.variant, component = _a.component, weight = _a.weight;
            var chosenColor = (0,_wds_styles__WEBPACK_IMPORTED_MODULE_2__/* .getColor */ .Lq)(palette, color, {
                fallback: palette.text.dark,
            });
            var variantStyle = {};
            if (variant) {
                if (isNotLink(variant)) {
                    variantStyle = {
                        fontSize: fontSize[variant],
                        fontWeight: {
                            hero1: fontWeight.light,
                            hero2: fontWeight.light,
                            title: fontWeight.light,
                            sectionTitle: fontWeight.light,
                            sectionTitleSm: fontWeight.light,
                            pageTitle: fontWeight.light,
                            cardTitle: fontWeight.regular,
                            body: fontWeight.regular,
                            bodySm: fontWeight.regular,
                            caption: fontWeight.regular,
                        }[variant],
                    };
                }
                else {
                    variantStyle = {
                        color: palette.link.main,
                        textDecoration: 'none',
                        border: 'none',
                        background: 'none',
                        outline: 'none',
                        cursor: 'pointer',
                        fontWeight: 'inherit',
                        fontSize: 'inherit',
                        '&:hover, &:focus': {
                            textDecoration: 'underline',
                        },
                    };
                }
            }
            var computedWeight = 'inherit';
            if (weight) {
                computedWeight = fontWeight[weight];
            }
            else if (component === 'strong') {
                computedWeight = fontWeight.medium;
            }
            else if (hasFontWeight(variantStyle)) {
                computedWeight = variantStyle.fontWeight;
            }
            return __assign(__assign(__assign({ fontFamily: fontFamily.base, fontSize: fontSize.body, boxSizing: 'border-box', '-webkit-font-smoothing': 'antialiased', color: chosenColor, textAlign: align, lineHeight: 1.5, margin: 0, padding: 0 }, variantStyle), (variant &&
                (variant === 'hero1' || variant === 'hero2') && {
                fontFamily: fontFamily === null || fontFamily === void 0 ? void 0 : fontFamily.headings,
            })), { fontWeight: computedWeight, '& > strong': {
                    fontWeight: fontWeight.medium,
                } });
        },
    };
});

var Typography = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_a, ref) {
    var _b = _a.align, align = _b === void 0 ? 'left' : _b, _c = _a.color, color = _c === void 0 ? 'dark' : _c, _d = _a.component, component = _d === void 0 ? 'div' : _d, _e = _a.variant, variant = _e === void 0 ? 'body' : _e, weight = _a.weight, children = _a.children, rest = __rest(_a, ["align", "color", "component", "variant", "weight", "children"]);
    var wrenchTypography = useStyles({
        align: align,
        color: color,
        variant: variant,
        component: component,
        weight: weight,
    }).wrenchTypography;
    var Component = component;
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(Component, __assign({ className: wrenchTypography }, (0,_wds_utils__WEBPACK_IMPORTED_MODULE_0__/* .safeRest */ .Q6)(rest), { ref: ref }), children));
});

var ALIGNMENTS = (/* unused pure expression or super */ null && (['center', 'left', 'right']));
var VARIANTS = __spreadArray(__spreadArray([], _wds_styles__WEBPACK_IMPORTED_MODULE_2__/* .FONT_SIZES */ .um, true), ['link'], false);
var TYPOGRAPHY_COLORS = __spreadArray(__spreadArray(__spreadArray([], _wds_styles__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_COLORS */ .kg, true), _wds_styles__WEBPACK_IMPORTED_MODULE_2__/* .LINK_COLORS */ .u5, true), _wds_styles__WEBPACK_IMPORTED_MODULE_2__/* .TYPE_COLORS */ .nk, true);
var COMPONENTS = (/* unused pure expression or super */ null && ([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'a',
    'p',
    'span',
    'div',
    'article',
    'section',
    'em',
    'strong',
]));




/***/ }),

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 6667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ClientError_Links; }
});

// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var dist_index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/Links/useStyles.js

var useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(_ref) {
    var border = _ref.border, palette = _ref.palette;
    return {
        linkList: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            padding: 0,
            margin: 0,
            listStyleType: "none"
        },
        linkItem: {
            "&:not(:last-child)": {
                "&::after": {
                    content: '"|"',
                    margin: "0 3px"
                }
            }
        },
        linkAnchor: {
            color: palette.link.main,
            textDecoration: "none",
            fontWeight: "inherit",
            fontSize: "inherit",
            "&:hover": {
                textDecoration: "underline"
            },
            "&:focus": {
                textDecoration: "none",
                outlineStyle: "auto",
                outlineWidth: "1px",
                outlineColor: border.hover,
                outlineOffset: "1px"
            }
        }
    };
});
/* harmony default export */ var Links_useStyles = (useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/Links/index.js
var _excluded = [
    "links"
];
var _jsxFileName = "/repo/packages/webassets/src/components/ClientError/Links/index.tsx", _this = undefined;
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var COPY = (0,dist/* defineMessages */.vU)({
    HOME: {
        id: "Links.home",
        defaultMessage: "Home",
        description: "[Type: Label][Vis.: med] - Home link in Error Message"
    },
    SITEMAP: {
        id: "Links.sitemap",
        defaultMessage: "Sitemap",
        description: "[Type: Label][Vis.: med] - Sitemap link in Error Message"
    },
    HELP_CENTER: {
        id: "Links.helpCenter",
        defaultMessage: "Help Center",
        description: "[Type: Label][Vis.: med] - Help Center link in Error Message"
    },
    TEMPLATES: {
        id: "Links.templates",
        defaultMessage: "Templates",
        description: "[Type: Label][Vis.: med] - Templates link in Error Message"
    },
    LEARN_MORE: {
        id: "Links.learnMore",
        defaultMessage: "Learn More",
        description: "[Type: Label][Vis.: med] - Learn More link in 404 Error Message"
    }
});
var defaultLinks = [
    {
        href: "/",
        label: (0,dist.t)(COPY.HOME)
    },
    {
        href: "/mp/sitemap/",
        label: (0,dist.t)(COPY.SITEMAP)
    },
    {
        href: "https://help.surveymonkey.com/",
        label: (0,dist.t)(COPY.HELP_CENTER)
    },
    {
        href: "/mp/survey-templates/",
        label: (0,dist.t)(COPY.TEMPLATES)
    },
    {
        href: "/mp/take-a-tour/",
        label: (0,dist.t)(COPY.LEARN_MORE)
    }
];
var Links = function Links(_ref) {
    var _ref$links = _ref.links, links = _ref$links === void 0 ? defaultLinks : _ref$links, containerBoxProps = _objectWithoutProperties(_ref, _excluded);
    var _useStyles = Links_useStyles(), linkList = _useStyles.linkList, linkStyles = _useStyles.linkItem, linkAnchor = _useStyles.linkAnchor;
    return /*#__PURE__*/ react.createElement(dist_index_es/* Box */.x, Object.assign({}, containerBoxProps, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 74,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(index_es/* Typography */.ZT, {
        component: "div",
        variant: "bodySm",
        align: "center",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 75,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("nav", {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 76,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement("ul", {
        className: linkList,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 77,
            columnNumber: 11
        }
    }, links.map(function(link) {
        return /*#__PURE__*/ react.createElement("li", {
            className: linkStyles,
            key: link.label,
            "data-testid": "ClientError_Link",
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 79,
                columnNumber: 15
            }
        }, /*#__PURE__*/ react.createElement("a", {
            className: linkAnchor,
            href: link.href,
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 84,
                columnNumber: 17
            }
        }, link.label));
    })))));
};
/* harmony default export */ var ClientError_Links = (Links); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 3613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ClientError_SignupButton; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var dist_index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@wds/button/dist/index.es.js + 1 modules
var button_dist_index_es = __webpack_require__(7837);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/SignupButton/useStyles.js

var useStyles = (0,react_jss_esm/* createUseStyles */.QM)({
    container: {
        "& a:hover, & a:focus": {
            textDecoration: "none"
        }
    }
});
/* harmony default export */ var SignupButton_useStyles = (useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/SignupButton/index.js
var _excluded = [
    "buttonProps",
    "signUpText"
];
var _jsxFileName = "/repo/packages/webassets/src/components/ClientError/SignupButton/index.tsx", _this = undefined;
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var DEFAULT_COPY = (0,dist/* defineMessages */.vU)({
    SIGN_UP_TEXT: {
        id: "SignupButton.signUpText",
        defaultMessage: "Want to create your own survey?",
        description: "[Type: Label][Vis.: med] - Sign up free button description text"
    },
    SIGN_UP_FREE: {
        id: "SignupButton.signUpFree",
        defaultMessage: "Sign Up FREE",
        description: "[Type: Label][Vis.: med] - Sign up free button"
    }
});
var DEFAULT_HREF = "/user/sign-up/?ut_source=404_page";
var SignupButton = function SignupButton(_ref) {
    var _buttonProps$label, _buttonProps$href;
    var buttonProps = _ref.buttonProps, signUpText = _ref.signUpText, containerBoxProps = _objectWithoutProperties(_ref, _excluded);
    var _useStyles = SignupButton_useStyles(), container = _useStyles.container;
    var buttonLabel = (_buttonProps$label = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.label) !== null && _buttonProps$label !== void 0 ? _buttonProps$label : (0,dist.t)(DEFAULT_COPY.SIGN_UP_FREE);
    var buttonHref = (_buttonProps$href = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.href) !== null && _buttonProps$href !== void 0 ? _buttonProps$href : DEFAULT_HREF;
    var description = signUpText !== null && signUpText !== void 0 ? signUpText : (0,dist.t)(DEFAULT_COPY.SIGN_UP_TEXT);
    return /*#__PURE__*/ react.createElement(dist_index_es/* Box */.x, Object.assign({}, containerBoxProps, {
        className: container,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 44,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(dist_index_es/* Box */.x, {
        mb: 4,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 45,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(index_es/* Typography */.ZT, {
        component: "div",
        variant: "cardTitle",
        align: "center",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 46,
            columnNumber: 9
        }
    }, description)), /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        href: buttonHref,
        color: "upgrade",
        size: "lg",
        "data-testid": "ClientError_SignUpButton",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 50,
            columnNumber: 7
        }
    }, buttonLabel));
};
/* harmony default export */ var ClientError_SignupButton = (SignupButton); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 7517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XF": function() { return /* reexport */ ClientError_ClientError; },
  "Fs": function() { return /* reexport */ withHttpErrorPage; }
});

// UNUSED EXPORTS: ClientErrorLinks, ClientErrorPage, ClientErrorSignup

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var dist_index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/theme/index.js
var theme = __webpack_require__(9681);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/useStyles.js

var useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(_ref) {
    var palette = _ref.palette, border = _ref.border, radius = _ref.radius, breakpoints = _ref.breakpoints;
    return {
        wrapper: function wrapper(_ref2) {
            var fullscreen = _ref2.fullscreen;
            return !fullscreen ? {} : {
                display: "flex",
                justifyContent: "center",
                padding: "150px 0"
            };
        },
        innerWrapper: {
            maxWidth: breakpoints.sm
        },
        title: {
            "& *": {
                lineHeight: "1.3"
            }
        },
        outerBox: {
            // converting border to string as workaround to JSS bug (unable to pass in styles while using a border array)
            border: "".concat(border.main[0], "px ").concat(border.main[1], " ").concat(border.main[2]),
            borderRadius: radius.small,
            backgroundColor: palette.background.light
        },
        content: {
            "& p": {
                lineHeight: "1.4",
                margin: 0
            }
        }
    };
});
/* harmony default export */ var ClientError_useStyles = (useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/ClientError.js
var _jsxFileName = "/repo/packages/webassets/src/components/ClientError/ClientError.tsx", _this = undefined;






// Exported as a named-component for use without ThemeProvider
var ClientError = function ClientError(_ref) {
    var openingMessage = _ref.openingMessage, errorTitle = _ref.errorTitle, _ref$titularElementTa = _ref.titularElementTag, titularElementTag = _ref$titularElementTa === void 0 ? "p" : _ref$titularElementTa, _ref$fullscreen = _ref.fullscreen, fullscreen = _ref$fullscreen === void 0 ? true : _ref$fullscreen, children = _ref.children, className = _ref.className, _ref$dataTestid = _ref["data-testid"], dataTestId = _ref$dataTestid === void 0 ? "ClientError" : _ref$dataTestid;
    var _useStyles = ClientError_useStyles({
        fullscreen: fullscreen
    }), wrapper = _useStyles.wrapper, innerWrapper = _useStyles.innerWrapper, title = _useStyles.title, outerBox = _useStyles.outerBox, content = _useStyles.content;
    return /*#__PURE__*/ react.createElement(dist_index_es/* Box */.x, {
        className: wrapper,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 32,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()(innerWrapper, className),
        "data-testid": dataTestId,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 33,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(index_es/* Typography */.ZT, {
        variant: "pageTitle",
        align: "center",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 37,
            columnNumber: 9
        }
    }, openingMessage), /*#__PURE__*/ react.createElement(dist_index_es/* Box */.x, {
        p: 6,
        mt: 6,
        className: outerBox,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 40,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(index_es/* Typography */.ZT, {
        component: titularElementTag,
        variant: "sectionTitle",
        align: "center",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 41,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement("span", {
        className: title,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 46,
            columnNumber: 13
        }
    }, errorTitle)), /*#__PURE__*/ react.createElement(index_es/* Typography */.ZT, {
        component: "div",
        variant: "body",
        align: "center",
        color: "darkMuted",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 48,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: content,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 54,
            columnNumber: 13
        }
    }, children)))));
};
/* harmony default export */ var ClientError_ClientError = ((0,theme/* withWebAssetsTheme */.I6)(ClientError)); //# sourceMappingURL=ClientError.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(2222);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Logos/index.js + 3 modules
var Logos = __webpack_require__(7120);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/useErrorPageStyles.js

function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var useErrorPageStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(_ref) {
    var palette = _ref.palette, spacing = _ref.spacing, breakpoints = _ref.breakpoints, elevation = _ref.elevation, type = _ref.type;
    return {
        pageContainer: {
            backgroundColor: palette.background.main,
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column"
        },
        hashMessageId: {
            fontFamily: type.fontFamily.base,
            color: "#6B787F",
            fontSize: 12,
            position: "fixed",
            bottom: 24,
            right: 0,
            left: 0,
            textAlign: "center",
            margin: 0
        },
        childrenContainer: _defineProperty({
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        }, "@media (max-width: ".concat(breakpoints.sm, "px), (max-height: ").concat(breakpoints.sm, "px)"), {
            position: "static"
        }),
        pageLogoLink: {
            display: "inline-block",
            position: "relative",
            zIndex: elevation.sky,
            margin: spacing[5],
            width: 200,
            height: 30
        }
    };
});
/* harmony default export */ var useErrorPageStyles = (useErrorPageStyles_useStyles); //# sourceMappingURL=useErrorPageStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/ClientErrorPage.js

var _excluded = [
    "errorCode"
], _excluded2 = [
    "requestId"
];
var ClientErrorPage_jsxFileName = "/repo/packages/webassets/src/components/ClientError/ClientErrorPage.tsx", ClientErrorPage_this = undefined;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            ClientErrorPage_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ClientErrorPage_defineProperty(obj, key, value) {
    key = ClientErrorPage_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ClientErrorPage_toPropertyKey(arg) {
    var key = ClientErrorPage_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function ClientErrorPage_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var HttpErrorPage = function HttpErrorPage(_ref) {
    var children = _ref.children, errorCode = _ref.errorCode, requestId = _ref.requestId;
    var _useStyles = useErrorPageStyles(), pageContainer = _useStyles.pageContainer, childrenContainer = _useStyles.childrenContainer, pageLogoLink = _useStyles.pageLogoLink, hashMessageId = _useStyles.hashMessageId;
    var logoLinkId = "HttpErrorPage_Logo_Link";
    var hashMessage = requestId ? "".concat(errorCode, ": ").concat(requestId) : "";
    var hashMessageTestId = "HttpErrorPage_Hash_Message";
    return /*#__PURE__*/ react.createElement("div", {
        className: pageContainer,
        __self: ClientErrorPage_this,
        __source: {
            fileName: ClientErrorPage_jsxFileName,
            lineNumber: 26,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("a", {
        href: "/",
        "data-testid": logoLinkId,
        className: pageLogoLink,
        __self: ClientErrorPage_this,
        __source: {
            fileName: ClientErrorPage_jsxFileName,
            lineNumber: 27,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(Logos/* LogoWithText */.u, {
        __self: ClientErrorPage_this,
        __source: {
            fileName: ClientErrorPage_jsxFileName,
            lineNumber: 28,
            columnNumber: 9
        }
    })), /*#__PURE__*/ react.createElement("div", {
        className: childrenContainer,
        __self: ClientErrorPage_this,
        __source: {
            fileName: ClientErrorPage_jsxFileName,
            lineNumber: 30,
            columnNumber: 7
        }
    }, children), /*#__PURE__*/ react.createElement("div", {
        "data-testid": hashMessageTestId,
        className: hashMessageId,
        __self: ClientErrorPage_this,
        __source: {
            fileName: ClientErrorPage_jsxFileName,
            lineNumber: 31,
            columnNumber: 7
        }
    }, hashMessage));
};
var withHttpErrorPage = function withHttpErrorPage(Component, _ref2) {
    var errorCode = _ref2.errorCode, defaultComponentProps = _objectWithoutProperties(_ref2, _excluded);
    return function(_ref3) {
        var requestId = _ref3.requestId, props = _objectWithoutProperties(_ref3, _excluded2);
        var componentProps = _objectSpread(_objectSpread({}, defaultComponentProps), props);
        return /*#__PURE__*/ react.createElement(HttpErrorPage, {
            errorCode: errorCode,
            requestId: requestId,
            __self: ClientErrorPage_this,
            __source: {
                fileName: ClientErrorPage_jsxFileName,
                lineNumber: 53,
                columnNumber: 7
            }
        }, /*#__PURE__*/ react.createElement(Component, Object.assign({}, componentProps, {
            fullscreen: false,
            __self: ClientErrorPage_this,
            __source: {
                fileName: ClientErrorPage_jsxFileName,
                lineNumber: 54,
                columnNumber: 9
            }
        })));
    };
};
/* harmony default export */ var ClientErrorPage = ((0,theme/* withWebAssetsTheme */.I6)(HttpErrorPage)); //# sourceMappingURL=ClientErrorPage.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/SignupButton/index.js + 1 modules
var SignupButton = __webpack_require__(3613);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/Links/index.js + 1 modules
var Links = __webpack_require__(6667);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/index.js



 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 7120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ Logos_Logo; },
  "u": function() { return /* reexport */ Logos_LogoWithText; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@wds/icons/dist/index.es.js
var index_es = __webpack_require__(9224);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var dist_index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/theme/index.js
var theme = __webpack_require__(9681);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Logos/Logo.js
var _excluded = [
    "color",
    "className"
];
var _jsxFileName = "/repo/packages/webassets/src/components/Logos/Logo.tsx", _this = undefined;
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Logo = function Logo(props) {
    return /*#__PURE__*/ react.createElement(theme/* WebAssetsThemeWrapper */.at, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    }, /*#__PURE__*/ react.createElement(LogoContent, Object.assign({}, props, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 15,
            columnNumber: 5
        }
    })));
};
var LogoContent = function LogoContent(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "primary" : _ref$color, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, other = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ react.createElement(dist_index_es/* Box */.x, Object.assign({
        display: "inline-flex",
        className: className
    }, other, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 25,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(index_es/* IconLogoGoldie */.jNx, {
        title: "SurveyMonkey Logo",
        color: color === "primary" ? "primary" : "light",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 26,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var Logos_Logo = (Logo); //# sourceMappingURL=Logo.js.map

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/theming/dist/theming.esm.js
var theming_esm = __webpack_require__(1928);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Logos/useStyles.js

var useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(_ref) {
    var palette = _ref.palette;
    return {
        logo: function logo(props) {
            return {
                color: props.color === "alt" ? palette.text.light : palette.primary.main,
                fill: props.color === "alt" ? palette.text.light : palette.primary.main
            };
        }
    };
});
/* harmony default export */ var Logos_useStyles = (useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Logos/LogoWithText.js
var LogoWithText_jsxFileName = "/repo/packages/webassets/src/components/Logos/LogoWithText.tsx", LogoWithText_this = undefined;





var LogoWithText = function LogoWithText(props) {
    return /*#__PURE__*/ react.createElement(theme/* WebAssetsThemeWrapper */.at, {
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 11,
            columnNumber: 3
        }
    }, /*#__PURE__*/ react.createElement(LogoWithTextContent, Object.assign({}, props, {
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 12,
            columnNumber: 5
        }
    })));
};
var LogoWithTextContent = function LogoWithTextContent(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "primary" : _ref$color, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
    var theme = (0,theming_esm/* useTheme */.Fg)();
    var _useStyles = Logos_useStyles({
        color: color,
        theme: theme
    }), logo = _useStyles.logo;
    return /*#__PURE__*/ react.createElement("svg", {
        id: "Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 505.84 75.76",
        className: classnames_default()(logo, className),
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 24,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("title", {
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 31,
            columnNumber: 7
        }
    }, "SurveyMonkey logo with text in ".concat(color)), /*#__PURE__*/ react.createElement("g", {
        id: "_Group_",
        "data-name": "<Group>",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 32,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_",
        "data-name": "<Compound Path>",
        d: "M144.72,87.19l4.12-4.9c3.73,3.23,7.45,5.06,12.29,5.06,4.23,0,6.9-1.95,6.9-4.9v-.11c0-2.78-1.56-4.28-8.79-6-8.29-2-13-4.45-13-11.63v-.11c0-6.67,5.56-11.29,13.3-11.29a21.58,21.58,0,0,1,14.13,4.9L170,63.44c-3.5-2.61-7-4-10.57-4-4,0-6.34,2.06-6.34,4.62v.11c0,3,1.78,4.34,9.23,6.12,8.23,2,12.52,5,12.52,11.4v.11c0,7.29-5.73,11.63-13.91,11.63A24,24,0,0,1,144.72,87.19Z",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 33,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_2",
        "data-name": "<Compound Path>",
        d: "M179.36,82.19V63.5h6.73V80.19c0,4.56,2.28,7.18,6.29,7.18S199,84.64,199,80.07V63.5h6.73V92.87H199v-3a11.58,11.58,0,0,1-9.18,3.64C183.2,93.48,179.36,89,179.36,82.19Z",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 39,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_3",
        "data-name": "<Compound Path>",
        d: "M212.93,63.5h6.73v4.9c1.83-4.4,5.23-5.68,10.4-5.45v6h-.39c-5.9,0-10,3.94-10,12.78V92.87h-6.73Z",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 45,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_4",
        "data-name": "<Compound Path>",
        d: "M232.46,63.5h7.23l7.9,20.44,8-20.44h7.06l-12,29.6h-6.06Z",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 51,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_5",
        "data-name": "<Compound Path>",
        d: "M262.66,78.29v-.11c0-8.4,6-15.3,14.35-15.3,9.35,0,14.08,7.34,14.08,15.8,0,.61-.06,1.22-.11,1.89H269.39c.72,4.78,4.12,7.46,8.46,7.46a10.67,10.67,0,0,0,8-3.51L289.75,88a14.86,14.86,0,0,1-12,5.5C269.23,93.53,262.66,87.36,262.66,78.29Zm21.75-2.17c-.44-4.34-3-7.73-7.45-7.73-4.12,0-7,3.17-7.62,7.73Z",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 57,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_6",
        "data-name": "<Compound Path>",
        d: "M326.76,53.93h7.29L345.9,73.79l11.85-19.86H365V92.87H358.2V64.94L345.9,84.75h-.22L333.5,65.05V92.87h-6.73Z",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 63,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_7",
        "data-name": "<Compound Path>",
        d: "M369.86,78.35v-.11a15.66,15.66,0,0,1,31.32-.11v.11a15.36,15.36,0,0,1-15.74,15.3A15.19,15.19,0,0,1,369.86,78.35Zm24.59,0v-.11c0-5.17-3.73-9.46-9-9.46s-8.85,4.23-8.85,9.35v.11c0,5.12,3.73,9.46,9,9.46C391,87.7,394.45,83.41,394.45,78.35Z",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 69,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_8",
        "data-name": "<Compound Path>",
        d: "M438.83,52.26h6.73V76.51l12.18-13h8.18l-11.68,12,12.07,17.41h-7.79l-8.85-12.68-4.12,4.28v8.4h-6.73Z",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 75,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_9",
        "data-name": "<Compound Path>",
        d: "M465.77,78.29v-.11c0-8.4,6-15.3,14.35-15.3,9.35,0,14.08,7.34,14.08,15.8,0,.61-.06,1.22-.11,1.89H472.5c.72,4.78,4.12,7.46,8.46,7.46a10.66,10.66,0,0,0,8-3.51L492.86,88a14.86,14.86,0,0,1-12,5.5C472.33,93.53,465.77,87.36,465.77,78.29Zm21.75-2.17c-.44-4.34-3-7.73-7.45-7.73-4.12,0-7,3.17-7.62,7.73Z",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 81,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement("polygon", {
        id: "_Path_",
        "data-name": "<Path>",
        points: "283.41 32.18 275.28 52.21 267.21 32.18 260.2 32.18 271.77 60.87 265.73 75.75 272.74 75.75 290.42 32.18 283.41 32.18",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 87,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_10",
        "data-name": "<Compound Path>",
        d: "M532.33,64a4.11,4.11,0,0,0-2,.52,3.79,3.79,0,0,0-1.52,1.49,4.24,4.24,0,0,0-.54,2,4.07,4.07,0,0,0,.53,2,3.79,3.79,0,0,0,1.5,1.49,4,4,0,0,0,4,0,3.78,3.78,0,0,0,1.49-1.49,4.07,4.07,0,0,0,0-4,3.69,3.69,0,0,0-1.51-1.49,4.16,4.16,0,0,0-2-.52m0-.8a4.9,4.9,0,0,1,2.37.63,4.35,4.35,0,0,1,1.81,1.78,4.8,4.8,0,0,1,0,4.82,4.56,4.56,0,0,1-1.79,1.79,4.87,4.87,0,0,1-2.4.63,5,5,0,0,1-2.41-.63,4.55,4.55,0,0,1-1.79-1.79,4.9,4.9,0,0,1-.63-2.39,4.79,4.79,0,0,1,.65-2.42,4.4,4.4,0,0,1,1.8-1.78,5,5,0,0,1,2.38-.63",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 92,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement("g", {
        id: "_Group_2",
        "data-name": "<Group>",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 98,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_11",
        "data-name": "<Compound Path>",
        d: "M530.28,65.36h2.41a2.18,2.18,0,0,1,1.56.54,1.64,1.64,0,0,1,.45,1.17v0a1.62,1.62,0,0,1-1.28,1.64l1.46,2h-1.13l-1.33-1.89h-1.19v1.89h-1ZM532.62,68c.68,0,1.11-.36,1.11-.9v0c0-.58-.42-.9-1.12-.9h-1.38V68Z",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 99,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("polygon", {
        id: "_Path_2",
        "data-name": "<Path>",
        points: "486.52 32.18 478.39 52.21 470.31 32.18 463.31 32.18 474.88 60.87 468.84 75.75 475.85 75.75 493.53 32.18 486.52 32.18",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 106,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_12",
        "data-name": "<Compound Path>",
        d: "M432,74.18V92.87h-6.73V76.18C425.24,71.62,423,69,419,69s-6.62,2.73-6.62,7.29V92.87H405.6V63.5h6.73v3a11.58,11.58,0,0,1,9.18-3.64C428.13,62.88,432,67.33,432,74.18Z",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 111,
            columnNumber: 9
        }
    })), /*#__PURE__*/ react.createElement("path", {
        id: "_Compound_Path_13",
        "data-name": "<Compound Path>",
        d: "M118.49,70.66a11.78,11.78,0,0,0-2.79.35,36,36,0,0,0-28.5-26.56c-.62-.11-1.18-.19-1.81-.27h0c.1-3.4.26-7.33,5.27-10.87l-.79-2s-9.75,3-10.88,11.37c-.49-2.27-5-5.11-7.28-5.65l-1.12,1.81a7.84,7.84,0,0,1,3.71,5.61h0A36,36,0,0,0,45.79,71a11.68,11.68,0,1,0,1.47,22.19,35.8,35.8,0,0,0,3.79,7.06l9.69-6.53-.08-.11a23.87,23.87,0,0,1-4.39-13c-.29-5.32,1-10.61,4.41-13.72,7-6,14.64-3.25,19.42,2.47h1.29c4.78-5.72,12.41-8.44,19.42-2.47,3.4,3.11,4.7,8.4,4.41,13.72a23.87,23.87,0,0,1-4.39,13l-.08.11,9.69,6.53a35.8,35.8,0,0,0,3.79-7.06,11.67,11.67,0,1,0,4.27-22.54ZM42.77,85.78a3.45,3.45,0,0,1,0-6.89,3.47,3.47,0,0,1,1.93.6,52.34,52.34,0,0,0,.37,5.41A3.45,3.45,0,0,1,42.77,85.78Zm75.95,0a3.45,3.45,0,0,1-2.3-.88,52.34,52.34,0,0,0,.37-5.41,3.44,3.44,0,0,1,5.37,2.86A3.44,3.44,0,0,1,118.71,85.78Z",
        transform: "translate(-31.32 -31.32)",
        __self: LogoWithText_this,
        __source: {
            fileName: LogoWithText_jsxFileName,
            lineNumber: 118,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var Logos_LogoWithText = (LogoWithText); //# sourceMappingURL=LogoWithText.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Logos/index.js

 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 9681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I6": function() { return /* binding */ withWebAssetsTheme; },
/* harmony export */   "at": function() { return /* binding */ WebAssetsThemeWrapper; }
/* harmony export */ });
/* unused harmony exports WebAssetsThemeProvider, useWebAssetsTheme */
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2222);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1928);
/* harmony import */ var _wds_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4779);

var _jsxFileName = "/repo/packages/webassets/src/theme/index.tsx", _this = undefined;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}



var ThemeContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var theming = (0,react_jss__WEBPACK_IMPORTED_MODULE_3__/* .createTheming */ .d5)(ThemeContext);
var WebAssetsThemeProvider = theming.ThemeProvider, useWebAssetsTheme = theming.useTheme;
var WebAssetsThemeWrapper = function WebAssetsThemeWrapper(_ref) {
    var children = _ref.children;
    var theme = useWebAssetsTheme();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_jss__WEBPACK_IMPORTED_MODULE_3__/* .ThemeProvider */ .f6, {
        theme: _objectSpread(_objectSpread({}, _wds_styles__WEBPACK_IMPORTED_MODULE_2__/* .WrenchTheme */ .Qb), theme),
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 17,
            columnNumber: 5
        }
    }, children);
};
var withWebAssetsTheme = function withWebAssetsTheme(Component) {
    return function(props) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(WebAssetsThemeWrapper, {
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 27,
                columnNumber: 5
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Component, Object.assign({}, props, {
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 28,
                columnNumber: 7
            }
        })));
    };
};
 //# sourceMappingURL=index.js.map


/***/ })

}]);